import type { IIssueInfo } from '@pressreader/content-types';
import { navigateToAction } from '@pressreader/navigation-core';
import { ViewName } from '@pressreader/navigation-types';
import { formatDate } from '@pressreader/resources';
import type { ArticleNavConfig } from '@pressreader/views-navigation';

/**
 * Function to create an action for navigating to an article.
 *
 * @param issueInfo - Issue info object containing date and slugs
 * @param articleId - The ID of the article to navigate to
 * @returns - an action to dispatch for navigating to the article
 */
export function getNavigateToArticleActionByIssueInfo(issueInfo: Pick<IIssueInfo, 'date' | 'slugs'>, articleId: string) {
    const params: Partial<ArticleNavConfig> = {
        articleId,
        issueDate: formatDate(issueInfo.date, 'yyyyMMdd'),
        country: issueInfo.slugs.country,
        newspaper: issueInfo.slugs.newspaper,
    };

    return navigateToAction({ viewName: ViewName.Article, params });
}
